import React from 'react';
import WeekConfiguration from "./WeekConfiguration";
import {injectIntl} from "react-intl";
import withAuthorization from "../../../services/Authorization";
import RentalPlanning from "./RentalPlanning";
import connect from "react-redux/es/connect/connect";
import MonthConfiguration from "./MonthConfiguration";

import "./PlanningManagement.css"
import "../HalfDayStatus.css"

class PlanningManagement extends React.Component {

  componentDidMount() {
    this.props.dispatchFetchMobility();
    this.props.dispatchFetchMainServices();
  }

  render() {
    const {intl:{formatMessage}} = this.props;

    return (
      <div>
        <header className="main-header">
          <div className="main-header__left">
            <h1 className="main__title">
              {formatMessage({id:'page.planning-management'})}
            </h1>
          </div>
        </header>

        <div className="main__content">
          <WeekConfiguration/>
          <MonthConfiguration/>
          <RentalPlanning/>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  dispatchFetchMainServices: () => dispatch({type: 'FETCH_MAIN_SERVICES.REQUEST'}),
  dispatchFetchMobility: () => dispatch({type: 'FETCH_MOBILITY.REQUEST'})
});

export default connect(
  null,
  mapDispatchToProps
)(withAuthorization(injectIntl(PlanningManagement), ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']));
